import { ChangeDetectorRef, Component, Inject, Input, LOCALE_ID, OnInit, Optional, ViewChild } from '@angular/core';
import { DatagridComponent } from '@farris/ui-datagrid';
import { EditorTypes } from '@farris/ui-datagrid-editors';
import { MessagerService } from '@farris/ui-messager';
import { ExprEditMode, ExpressionService, InjectedType, VarEntity } from '@gsp-svc/expression';
import { ProcessDesignerUIState } from '../../app/process-designer.uistate';
import { SmsMessageTemplate, SmsMessageVariable } from './sms-message-template';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../i18n/assets/lang.resource';

@Component({
  selector: 'lib-sms-message-template',
  templateUrl: './sms-message-template.component.html',
  styleUrls: ['./sms-message-template.component.scss'],
  providers: [
     WfLocalePipe,
  ]
})
export class SmsMessageTemplateComponent implements OnInit {

  @ViewChild('grid') grid: DatagridComponent;

  smsVariableList = new Array();
  smsVariableCols = new Array();
  smsTemplateContent = this.localePipe.transform('component.smsMessageTemplate.smsTemplateContent')

  @Input()
  smsMessageTemplate: SmsMessageTemplate;

  constructor(
    private designerState: ProcessDesignerUIState,
    private expr: ExpressionService,
    private message: MessagerService,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
    this.smsMessageTemplate = new SmsMessageTemplate();
  }

  ngOnInit() {
    this.smsVariableCols=[{
      field: 'code', width: 80, title: this.localePipe.transform('component.smsMessageTemplate.code'), editor: { type: EditorTypes.TEXTBOX, options: {} }
    }, {
      field: 'value', width: 100, title: this.localePipe.transform('component.smsMessageTemplate.value'), showTips: true,editor: {
        type: 'input-group',
        options: {
          groupText: '<i class="f-icon f-icon-lookup"></i>',
          editable: false,
          clickHandle: (e) => {
            e.formControl.setValue(e.instance.value ? e.instance.value : '');
            this.showExprHelp(e);
          },
          clear: (e) => {
            console.log('clear', e);
          }
        }
      }
      }]
    console.log(this.smsMessageTemplate);
  }

  addSmsVariable() {
    const variable = new SmsMessageVariable();
    this.smsMessageTemplate.smsMessageVariables.push(variable);
    this.grid.loadData(this.smsMessageTemplate.smsMessageVariables);
  }

  deleteSmsVariable() {
    this.endGridEdit();
    const selectedVariable = this.grid.selectedRow;
    if (!selectedVariable) {
      this.message.info(this.localePipe.transform('component.smsMessageTemplate.noRowsSelected'));
      return;
    }
    const index = this.smsMessageTemplate.smsMessageVariables.findIndex(variable => variable.id === selectedVariable.id);
    if (index > -1) {
      this.smsMessageTemplate.smsMessageVariables.splice(index, 1);
      this.grid.loadData(this.smsMessageTemplate.smsMessageVariables);
    }
  }

  endGridEdit() {
    this.grid.endCellEdit();
  }

  private showExprHelp(e: any) {
    // this.expr.clearContext();
    if (this.designerState.schemas.length > 0) {
      for (const schema of this.designerState.schemas) {
        this.expr.addSchema('Schema', schema);
      }
      if (this.designerState.schemas[0].entityTypes && this.designerState.schemas[0].entityTypes.length > 0) {
        const entityType = this.designerState.schemas[0].entityTypes[0];
        this.expr.addInjectedEntity(entityType.name, 'Schema',
          entityType.name, InjectedType.EntityType);
      }
    }
    let context = new Array<VarEntity>();
    context = this.designerState.addContext(context);
    if (this.designerState.subActivityContext.length > 0) {
      for (const variable of this.designerState.subActivityContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (context.length > 0) {
      for (const v of context) {
        this.expr.addContext(v);
      }
    }
    this.expr.setEditPattern(ExprEditMode.Advanced); // 默认打开高级表达式编辑器
    this.expr.addExpressionText(e.instance.value);
    this.expr.buildExpression().then((expressioninfo: string) => {
      e.formControl.setValue(expressioninfo);
      e.instance.cd.detectChanges();
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }



}
